import type { Anime } from "@/types";

export const animeList: Anime[] = [
  {
    id: "sword-and-sky",
    title: "剑与苍穹",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20key%20visual%20poster%20illustration%20of%20a%20young%20swordsman%20standing%20on%20a%20rocky%20cliff%20edge%20facing%20a%20vast%20dramatic%20sky%2C%20flowing%20cape%2C%20glowing%20sword%2C%20epic%20fantasy%20atmosphere%2C%20cel-shaded%20digital%20painting%2C%20saturated%20colors%2C%20clean%20line%20art%2C%20dynamic%20composition%2C%20no%20text%2C%20high%20detail&width=600&height=800&seq=anime-cover-01&orientation=portrait",
    category: "热血",
    tags: ["热血", "冒险", "奇幻", "战斗"],
    region: "日本",
    year: "2024",
    status: "连载中",
    episodes: 24,
    latestEpisode: 18,
    rating: 9.3,
    popularity: 9820,
    updatedAt: "2024-06-18",
    synopsis:
      "少年凛在被诅咒的边境村庄长大，为了解开剑之诅咒踏上旅途。他手持会吞噬持有者记忆的魔剑，在旅途中结识了流浪骑士与神秘少女，一同揭开笼罩整片大陆的苍穹之谜。热血与羁绊交织的冒险物语就此展开。",
    episodeTitles: [
      "第1集 被诅咒的少年",
      "第2集 魔剑的低语",
      "第3集 边境的追兵",
      "第4集 流浪的骑士",
      "第5集 风起之时",
      "第6集 试炼之森",
      "第7集 沉睡的记忆",
      "第8集 少女与钟声",
      "第9集 断崖之战",
      "第10集 剑的代价",
      "第11集 破晓之前",
      "第12集 苍穹之门",
    ],
  },
  {
    id: "star-voyager",
    title: "星海旅人",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20key%20visual%20poster%20illustration%20of%20a%20curious%20child%20astronaut%20floating%20before%20a%20colossal%20starship%20in%20deep%20space%2C%20glowing%20nebula%20and%20distant%20planets%2C%20sense%20of%20wonder%2C%20cel-shaded%20digital%20painting%2C%20saturated%20colors%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=600&height=800&seq=anime-cover-02&orientation=portrait",
    category: "科幻",
    tags: ["科幻", "冒险", "太空", "成长"],
    region: "日本",
    year: "2024",
    status: "连载中",
    episodes: 12,
    latestEpisode: 9,
    rating: 8.9,
    popularity: 8730,
    updatedAt: "2024-06-15",
    synopsis:
      "在人类迁徙船「星海号」上出生的少年零，从未见过真正的地球。当飞船的导航系统突然失灵，他被迫驾驶一架老旧穿梭机，与机载人工智能一同踏上寻找失落航线的旅程，途中发现了关于人类起源的惊人真相。",
    episodeTitles: [
      "第1集 星海号的一天",
      "第2集 沉默的导航仪",
      "第3集 老旧的穿梭机",
      "第4集 沉睡的航线",
      "第5集 漂浮的残骸",
      "第6集 会说话的AI",
      "第7集 遥远的蓝点",
      "第8集 星尘的记忆",
      "第9集 归途坐标",
      "第10集 引力边缘",
    ],
  },
  {
    id: "promise-under-sakura",
    title: "樱花下的约定",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20key%20visual%20poster%20illustration%20of%20two%20high%20school%20students%20standing%20under%20a%20blooming%20cherry%20blossom%20tree%2C%20petals%20drifting%20in%20the%20wind%2C%20warm%20spring%20sunlight%2C%20soft%20romantic%20atmosphere%2C%20cel-shaded%20digital%20painting%2C%20saturated%20colors%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=600&height=800&seq=anime-cover-03&orientation=portrait",
    category: "恋爱",
    tags: ["恋爱", "校园", "治愈", "青春"],
    region: "日本",
    year: "2023",
    status: "已完结",
    episodes: 13,
    latestEpisode: 13,
    rating: 9.0,
    popularity: 8410,
    updatedAt: "2024-03-28",
    synopsis:
      "转学生樱井与文学部少年在满开的樱花树下立下约定——每年春天都在此重逢。七年间，两颗心在信笺与偶遇中靠近又错过。一段关于等待、成长与告白的青春恋爱故事，温柔得让人心颤。",
    episodeTitles: [
      "第1集 转学生",
      "第2集 樱花树下",
      "第3集 借书卡",
      "第4集 梅雨季",
      "第5集 文化祭",
      "第6集 未寄出的信",
      "第7集 夏天来了",
      "第8集 烟火大会",
      "第9集 渐远的距离",
      "第10集 第一场雪",
      "第11集 第七年春",
      "第12集 约定之地",
      "第13集 樱花下的约定",
    ],
  },
  {
    id: "spirit-fox",
    title: "灵狐物语",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20key%20visual%20poster%20illustration%20of%20a%20young%20shrine%20maiden%20with%20a%20glowing%20white%20spirit%20fox%20companion%20in%20an%20enchanted%20bamboo%20forest%2C%20floating%20lanterns%2C%20gentle%20magical%20glow%2C%20cel-shaded%20digital%20painting%2C%20saturated%20colors%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=600&height=800&seq=anime-cover-04&orientation=portrait",
    category: "治愈",
    tags: ["治愈", "奇幻", "日常", "妖怪"],
    region: "日本",
    year: "2024",
    status: "连载中",
    episodes: 16,
    latestEpisode: 11,
    rating: 8.7,
    popularity: 7250,
    updatedAt: "2024-06-12",
    synopsis:
      "小神社的巫女千夏能看见别人看不见的妖怪。当一只受伤的白色灵狐闯入她的生活，一人一狐开始为迷路的妖怪们寻找归途。每个短篇都是一段治愈人心的温情小故事。",
    episodeTitles: [
      "第1集 迷路的小狐",
      "第2集 神社的清晨",
      "第3集 雨夜来访",
      "第4集 灯笼祭",
      "第5集 山中回声",
      "第6集 老树的心愿",
      "第7集 迟到的信",
      "第8集 四季之约",
      "第9集 月下的舞",
      "第10集 百年的等",
      "第11集 归途",
    ],
  },
  {
    id: "urban-mystery",
    title: "都市异闻录",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20key%20visual%20poster%20illustration%20of%20a%20sharp-eyed%20detective%20in%20a%20rainy%20neon-lit%20city%20street%20at%20night%2C%20wet%20reflections%2C%20moody%20atmosphere%2C%20mysterious%20tension%2C%20cel-shaded%20digital%20painting%2C%20saturated%20colors%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=600&height=800&seq=anime-cover-05&orientation=portrait",
    category: "悬疑",
    tags: ["悬疑", "推理", "都市", "悬疑"],
    region: "日本",
    year: "2024",
    status: "连载中",
    episodes: 15,
    latestEpisode: 12,
    rating: 9.1,
    popularity: 9020,
    updatedAt: "2024-06-18",
    synopsis:
      "在这座不眠之城，每一起离奇案件背后都隐藏着超乎常理的真相。侦探夜见与助手小铃在霓虹灯下追寻线索，逐步逼近一个覆盖全城的巨大阴谋。冷峻的都市悬疑剧，每一集都让人屏息。",
    episodeTitles: [
      "第1集 雨夜的报案",
      "第2集 消失的证人",
      "第3集 镜像房间",
      "第4集 第七通电话",
      "第5集 地下铁之谜",
      "第6集 无声的证词",
      "第7集 双面之影",
      "第8集 天台对峙",
      "第9集 破碎的时钟",
      "第10集 隐藏的房间",
      "第11集 真相的代价",
      "第12集 霓虹尽头",
    ],
  },
  {
    id: "mecha-era",
    title: "机甲纪元",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20key%20visual%20poster%20illustration%20of%20a%20towering%20humanoid%20mecha%20robot%20standing%20over%20a%20futuristic%20city%20skyline%20at%20dusk%2C%20glowing%20cockpit%2C%20dramatic%20scale%2C%20sci-fi%20battle%20atmosphere%2C%20cel-shaded%20digital%20painting%2C%20saturated%20colors%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=600&height=800&seq=anime-cover-06&orientation=portrait",
    category: "科幻",
    tags: ["科幻", "机甲", "热血", "战斗"],
    region: "日本",
    year: "2023",
    status: "已完结",
    episodes: 26,
    latestEpisode: 26,
    rating: 8.8,
    popularity: 8890,
    updatedAt: "2024-02-20",
    synopsis:
      "当异星机械军团入侵，少年驾驶员们被召集到「机甲纪元」计划之中。主角苍真驾驶着父亲遗留的原型机，在一次次惨烈战斗中守护残存的城市，也逐渐理解了战争与人性的真正代价。",
    episodeTitles: [
      "第1集 觉醒",
      "第2集 初次出击",
      "第3集 原型机",
      "第4集 同伴",
      "第5集 失守的防线",
      "第6集 钢铁意志",
      "第7集 夜袭",
      "第8集 断裂的剑",
      "第9集 誓约",
      "第10集 反攻号角",
      "第11集 最后的命令",
      "第12集 黎明",
    ],
  },
  {
    id: "cat-cafe",
    title: "猫与咖啡屋",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20key%20visual%20poster%20illustration%20of%20a%20cozy%20cat%20cafe%20interior%20with%20several%20fluffy%20cats%20lounging%20among%20warm%20wooden%20furniture%20and%20hanging%20plants%2C%20soft%20afternoon%20light%2C%20wholesome%20atmosphere%2C%20cel-shaded%20digital%20painting%2C%20saturated%20colors%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=600&height=800&seq=anime-cover-07&orientation=portrait",
    category: "治愈",
    tags: ["治愈", "日常", "美食", "温馨"],
    region: "日本",
    year: "2024",
    status: "连载中",
    episodes: 12,
    latestEpisode: 8,
    rating: 8.5,
    popularity: 6120,
    updatedAt: "2024-06-10",
    synopsis:
      "辞职后接手外婆猫咖啡屋的优子，遇见了七只性格各异的猫咪和形形色色的客人。一杯咖啡、一只猫、一段心事，小小的咖啡屋成了都市里最温暖的角落。",
    episodeTitles: [
      "第1集 重新开张",
      "第2集 第一位客人",
      "第3集 挑食的橘猫",
      "第4集 午后的常客",
      "第5集 雨天的心情",
      "第6集 新来的小猫",
      "第7集 深夜菜单",
      "第8集 咖啡与猫",
    ],
  },
  {
    id: "dragon-heir",
    title: "龙之继承者",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20key%20visual%20poster%20illustration%20of%20a%20young%20dragon%20rider%20soaring%20above%20misty%20mountain%20peaks%20on%20a%20majestic%20dragon%2C%20epic%20fantasy%20scale%2C%20golden%20light%20breaking%20through%20clouds%2C%20cel-shaded%20digital%20painting%2C%20saturated%20colors%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=600&height=800&seq=anime-cover-08&orientation=portrait",
    category: "奇幻",
    tags: ["奇幻", "冒险", "巨龙", "史诗"],
    region: "日本",
    year: "2024",
    status: "连载中",
    episodes: 20,
    latestEpisode: 14,
    rating: 9.2,
    popularity: 9310,
    updatedAt: "2024-06-17",
    synopsis:
      "龙族的血脉在少年艾尔体内苏醒，他成为最后一位龙之继承者。为了阻止古老预言中的灾厄，他驾驭尚在幼年的巨龙，穿越风暴与荒原，寻找散落大陆的五枚龙鳞，书写属于自己的史诗。",
    episodeTitles: [
      "第1集 苏醒的血脉",
      "第2集 幼龙",
      "第3集 荒原的呼唤",
      "第4集 第一枚龙鳞",
      "第5集 风暴之眼",
      "第6集 古老的誓约",
      "第7集 天空的骑士",
      "第8集 废墟之城",
      "第9集 龙之歌",
      "第10集 第二枚龙鳞",
      "第11集 炎之试炼",
      "第12集 并肩飞翔",
    ],
  },
  {
    id: "summer-echo",
    title: "夏日回声",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20key%20visual%20poster%20illustration%20of%20a%20group%20of%20high%20school%20friends%20on%20a%20seaside%20summer%20evening%2C%20fireworks%20rising%20over%20the%20ocean%2C%20warm%20nostalgic%20glow%2C%20coming-of-age%20atmosphere%2C%20cel-shaded%20digital%20painting%2C%20saturated%20colors%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=600&height=800&seq=anime-cover-09&orientation=portrait",
    category: "校园",
    tags: ["校园", "青春", "恋爱", "治愈"],
    region: "日本",
    year: "2023",
    status: "已完结",
    episodes: 12,
    latestEpisode: 12,
    rating: 8.9,
    popularity: 7980,
    updatedAt: "2024-01-15",
    synopsis:
      "海边小镇的最后一个夏天，六位高中好友决定一起完成毕业前的清单。海风、烟火、告白与告别——那些再也回不去的夏日，化作心底最温柔的回声。",
    episodeTitles: [
      "第1集 海边的夏天",
      "第2集 毕业清单",
      "第3集 自行车与蝉鸣",
      "第4集 汽水与日落",
      "第5集 秘密的约定",
      "第6集 台风夜",
      "第7集 未完成的告白",
      "第8集 海浪与脚步",
      "第9集 最后的清单",
      "第10集 烟火大会",
      "第11集 离别之前",
      "第12集 夏日回声",
    ],
  },
  {
    id: "midnight-detective",
    title: "暗夜侦探",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20key%20visual%20poster%20illustration%20of%20a%20mysterious%20detective%20silhouette%20in%20a%20dark%20foggy%20alley%20lit%20by%20a%20single%20streetlamp%2C%20deep%20shadows%2C%20film-noir%20tension%2C%20cel-shaded%20digital%20painting%2C%20saturated%20colors%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=600&height=800&seq=anime-cover-10&orientation=portrait",
    category: "悬疑",
    tags: ["悬疑", "推理", "暗黑", "犯罪"],
    region: "日本",
    year: "2024",
    status: "连载中",
    episodes: 18,
    latestEpisode: 10,
    rating: 8.6,
    popularity: 7010,
    updatedAt: "2024-06-14",
    synopsis:
      "只在午夜之后接案的侦探雾岛，专门处理那些警方无法解开的悬案。每一桩案子都是一面镜子，照出人心的幽暗。随着调查深入，他发现所有案件都指向十年前的一件旧事。",
    episodeTitles: [
      "第1集 午夜的委托",
      "第2集 消失的钟声",
      "第3集 镜中之人",
      "第4集 无头信件",
      "第5集 旧案重启",
      "第6集 谎言阶梯",
      "第7集 沉默的邻居",
      "第8集 雨夜追逐",
      "第9集 真假之间",
      "第10集 十年前的秘密",
    ],
  },
  {
    id: "kendo-girl",
    title: "剑道少女",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20key%20visual%20poster%20illustration%20of%20a%20determined%20female%20high%20school%20kendo%20athlete%20in%20armor%20striking%20a%20powerful%20pose%20in%20a%20dojo%2C%20dynamic%20motion%2C%20inspirational%20energy%2C%20cel-shaded%20digital%20painting%2C%20saturated%20colors%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=600&height=800&seq=anime-cover-11&orientation=portrait",
    category: "热血",
    tags: ["热血", "运动", "校园", "励志"],
    region: "日本",
    year: "2024",
    status: "连载中",
    episodes: 14,
    latestEpisode: 9,
    rating: 8.8,
    popularity: 7560,
    updatedAt: "2024-06-16",
    synopsis:
      "身材娇小却无比倔强的少女葵，立志要打进全国剑道大赛。面对强大的对手与内心的迷惘，她在一次次挥剑中找回初心。汗水、友情与胜利交织的热血体育故事。",
    episodeTitles: [
      "第1集 加入剑道部",
      "第2集 第一场练习赛",
      "第3集 前辈的教导",
      "第4集 弱者的觉悟",
      "第5集 地区预选",
      "第6集 宿敌登场",
      "第7集 败北",
      "第8集 重新站起",
      "第9集 决赛之路",
    ],
  },
  {
    id: "letter-of-time",
    title: "时光信笺",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20key%20visual%20poster%20illustration%20of%20glowing%20handwritten%20letters%20and%20paper%20planes%20floating%20through%20warm%20golden%20light%20in%20a%20dreamy%20room%2C%20nostalgic%20magical%20atmosphere%2C%20cel-shaded%20digital%20painting%2C%20saturated%20colors%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=600&height=800&seq=anime-cover-12&orientation=portrait",
    category: "奇幻",
    tags: ["奇幻", "治愈", "时间", "温情"],
    region: "日本",
    year: "2023",
    status: "已完结",
    episodes: 11,
    latestEpisode: 11,
    rating: 9.0,
    popularity: 6890,
    updatedAt: "2024-04-05",
    synopsis:
      "旧邮局的抽屉里，藏着能寄往过去的信笺。少女遥偶然发现这个秘密后，开始给不同时间的人寄信，试图改变那些遗憾。然而每一封寄出的信，都在当下泛起意想不到的涟漪。",
    episodeTitles: [
      "第1集 会寄信的房间",
      "第2集 写给昨天",
      "第3集 未说出口的话",
      "第4集 回信",
      "第5集 时间的代价",
      "第6集 另一个自己",
      "第7集 停摆的钟",
      "第8集 重逢",
      "第9集 无法改变的事",
      "第10集 最后一封信",
      "第11集 时光信笺",
    ],
  },
];

export const regions = ["全部", "日本", "国产", "欧美", "其他"];

export const years = ["全部", "2024", "2023", "2022", "2021"];

export const statuses = ["全部", "连载中", "已完结"];